<template>
  <div class="item-list">
    <div class="inner-wrapper" v-if="list.length > 0">
          <div class="tab" v-for="(item, index) in list" :key="index">
            <input v-bind:id="'wrap-id-' + index" type="checkbox" name="tabs">
            <label v-bind:for="'wrap-id-' + index">
              <span class="checkmark">
                  <div class="checkmark_stem"></div>
                  <div class="checkmark_kick"></div>
              </span>
              <span>{{item.Title}}</span>
            </label>
            <div v-if="item.childElements" class="tab-content" v-bind:class="{ 'show-detail': showDetail, 'show-more-active': showMoreActiveClass() }">
              <ul @click="closeMenu">
                <li v-for="childElement in item.childElements" :key="childElement.title">
                  <router-link  v-if="!childElement.openNewTab && !childElement.externalUrl" :to="{ path: childElement.url }">{{ childElement.title }}</router-link>
                  <a v-if="childElement.openNewTab && !childElement.externalUrl" target="_blank" rel="noreferrer" v-bind:href="childElement.url">{{childElement.title}}</a>
                  <a v-if="childElement.externalUrl" target="_blank" rel="noreferrer" v-bind:href="childElement.externalUrl">{{childElement.title}}</a>
                </li>
              </ul>
            </div>
            <div v-else class="tab-content" v-bind:class="{ 'show-detail': showDetail, 'show-more-active': showMoreActiveClass() }">
              <ul>
                <li v-for="menuChildItem in item.Menus" :key="menuChildItem.Title" @click="closeMenu(menuChildItem.Url)">
                  <router-link v-if="menuChildItem.Url.indexOf('http') === -1 && menuChildItem.Url.indexOf('#newtab') === -1" :to="{ path: menuChildItem.Url }">{{menuChildItem.Title}}</router-link>
                  <a v-if="menuChildItem.Url.indexOf('http') !== -1 && menuChildItem.Url.indexOf('#newtab') === -1" :href="menuChildItem.Url" target="_blank" rel="noopener nofollow">{{menuChildItem.Title}}</a>
                  <a v-if="menuChildItem.Url.indexOf('#newtab') !== -1" v-on:click="openWindow(menuChildItem.Url)">{{menuChildItem.Title}}</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="show-more-text" v-if="showMoreActive" v-on:click='updateDetailStatus()'>
            <a v-if="!showDetail"><u>{{ $t("links.seeAll") }}</u></a>
            <a v-if="showDetail"><u>{{ $t("links.close") }}</u></a>
          </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemList',
  mounted () {
    var self = this
    if (self.listContent) {
      self.list = self.listContent
    }
  },
  data () {
    return {
      list: [],
      showDetail: false
    }
  },
  props: {
    listContent: {
      type: Array,
      default: function () { return [] }
    },
    showMoreActive: {
      type: Boolean,
      default: function () { return false }
    }
  },
  watch: {},
  methods: {
    openWindow (url) {
      return window.open(url.replace('#newtab', ''))
    },
    updateDetailStatus () {
      this.showDetail = !this.showDetail
    },
    showMoreActiveClass () {
      return (this.showMoreActive && !this.showDetail)
    },
    closeMenu: function (url) {
      if (url.indexOf('http') === -1) {
        this.$emit('closePanel')
      }
    }
  }
}
</script>
<style scoped>
  .item-list .inner-wrapper {
    height: 100%; 
    /*height: calc(100vh);*/
    overflow-y: auto;
  }
  .item-list .half {
    float: left;
    width: 50%;
    padding: 0 1em;
  }
  /* Acordeon styles */
  .item-list .tab {
    color: var(--text-color5);
  }
  .item-list .tab-content {
    max-height: 20em;
  }
  .header-buttons input {
    opacity: 1;
    z-index: 9998;
    position: relative;
  }
  .item-list .tab-content {
    max-height: 20em;
    overflow: hidden;
    -webkit-transition: max-height .35s;
    -o-transition: max-height .35s;
    transition: max-height .35s;
  }
  .item-list .tab-content ul {
    /*margin-left: 0.938em;*/
    margin-left: 6px;
    margin-bottom: 0.813em;
    size: 16px;
    line-height: 30px;
    letter-spacing: -0.4px;
  }
  .item-list input {
    position: absolute;
    visibility: hidden;
  }
  .show-detail {
    min-height: 3em;
  }
  .show-more-text {
    padding: 0.5em 0
  }
  .show-more-active {
    max-height: 5em !important;
  }
  .inner-wrapper .checkmark {
    /* display:inline-block; */
    width: 1.375em;
    height: 1.375em;
    -ms-transform: rotate(45deg); /* IE 9 */
    -webkit-transform: rotate(45deg); /* Chrome, Safari, Opera */
    transform: rotate(45deg);
    margin: 0 0.3125em;
    display: none;
  }
  .inner-wrapper .checkmark_stem {
    position: absolute;
    width: 0.25em;
    height: 1em;
    background-color: var(--text-color7);
    left: 0.875em;
    top: 0px;
    display: none;
  }
  .inner-wrapper .checkmark_kick {
    position: absolute;
    width: 0.625em;
    height: 0.25em;
    background-color: var(--text-color7);
    left: 0.5em;
    top: 0.75em;
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/shared/widget/itemList.vue